export const NATOFlag = ({ styles }: { styles?: React.CSSProperties }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="8 30 172 136"
    style={{ ...styles, maxWidth: '100px' }}
  >
    <path
      d="M30.473 97.696H8.504l.003 86.553 86.551.003v-21.969h1.32V96.377l-10.699 11.617 9.533 44.287-13.344-41.794-45.444-14.109h-5.951v1.318zm19.547 7.244l2.171.674c3.633 17.514 17.386 31.313 34.859 34.992l.7 2.183c-19.139-3.546-34.221-18.671-37.73-37.849z"
      fill="#4f89c8"
    />
    <path
      d="M184.252 8.504l-86.557.003v21.967h-1.318v65.903l10.699-11.615-9.533-44.287 13.344 41.795 45.441 14.107h5.955v-1.316h21.969V8.504zm-79.25 41.462c19.146 3.546 34.232 18.679 37.74 37.863l-2.174-.673c-3.629-17.525-17.389-31.332-34.869-35.008l-.697-2.182z"
      fill="#4f89c8"
    />
    <path
      d="M95.058 30.474V8.507L8.507 8.504l-.003 86.558h21.969v1.315h65.904l-11.6-10.713-44.22 9.549 41.731-13.366L96.377 36.34v60.037-65.903h-1.319zm-7.224 19.477l-.675 2.174c-17.491 3.636-31.275 17.409-34.947 34.911l-2.177.699c3.542-19.169 18.646-34.272 37.799-37.784zM162.283 97.696v-.438h-.002v-.881H96.377l11.597 10.716 44.225-9.546-41.732 13.364-14.089 45.506v5.866h1.318v21.969l86.557-.003V97.696h-21.97zm-19.562 7.328c-3.541 19.163-18.645 34.265-37.789 37.779l.674-2.175c17.484-3.638 31.266-17.409 34.938-34.906l2.177-.698z"
      fill="#234b8d"
    />
  </svg>
);
